// extracted by mini-css-extract-plugin
export default {"about":"common_about__q7GFq","Icons":"common_Icons__7DZhU"};